import type { TDecoratorSliderDirection } from "./types";
import { decoratorSlideVariant } from "./variables";

export const DecoratorSliderBall = (direction: TDecoratorSliderDirection) => {
  const { wrapperClass, lineClass } = decoratorSlideVariant[direction];

  const DecoratorElement = document.createElement("div");
  DecoratorElement.className = `${wrapperClass} items-center`;

  DecoratorElement.innerHTML = /* html */ `
        <div class="w-14 h-0.5 ${lineClass} from-white to-blue-150"></div>
        <div class="w-3 h-3 bg-blue-200 rounded-full"></div>
    `;

  return DecoratorElement;
};
